import { render, staticRenderFns } from "./MyGroupsMini.vue?vue&type=template&id=52bb234e&scoped=true&"
import script from "./MyGroupsMini.vue?vue&type=script&lang=js&"
export * from "./MyGroupsMini.vue?vue&type=script&lang=js&"
import style0 from "./MyGroupsMini.vue?vue&type=style&index=0&id=52bb234e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52bb234e",
  null
  
)

export default component.exports